import { useEffect, useState } from 'react';
import { PositionTypeEnum } from 'service/trading-demo';

export interface SettleSuccessPopupType {
  symbol: string;
  qty: number;
  positionType: PositionTypeEnum;
}

const SettleSuccessPopup = ({
  data,
  onClose,
}: {
  data: SettleSuccessPopupType;
  onClose: () => void;
}) => {
  const { symbol, qty } = data;
  const [showCheck, setShowCheck] = useState(false);

  useEffect(() => {
    // Show check animation after a short delay
    const checkTimer = setTimeout(() => {
      setShowCheck(true);
    }, 200);

    // Auto close after 2 seconds
    const closeTimer = setTimeout(() => {
      onClose();
    }, 2000);

    return () => {
      clearTimeout(checkTimer);
      clearTimeout(closeTimer);
    };
  }, [onClose]);

  if (!data) return null;

  return (
    <div className="all-font-sans pointer-events-none fixed inset-0 z-[9999] flex items-center justify-center">
      <div
        className={`pointer-events-auto transition-all duration-300 ease-in-out ${
          showCheck ? 'translate-y-0 opacity-100' : '-translate-y-5 opacity-0'
        }`}
      >
        <div className="flex min-w-[320px] max-w-[400px] items-center gap-4 rounded-xl bg-white p-5 shadow-2xl">
          {/* Icon with animation */}
          <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-gray-800">
            <svg
              viewBox="0 0 24 24"
              className={`size-6 text-white transition-all duration-300 ${
                showCheck ? 'scale-100 opacity-100' : 'scale-0 opacity-0'
              }`}
              style={{
                transform: showCheck ? 'scale(1)' : 'scale(0)',
                transition:
                  'transform 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
              }}
            >
              <polyline
                points="20 6 9 17 4 12"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={`transition-all duration-500 ${
                  showCheck
                    ? 'stroke-dasharray-20 stroke-dashoffset-0'
                    : 'stroke-dasharray-20 stroke-dashoffset-20'
                }`}
                style={{
                  strokeDasharray: '20',
                  strokeDashoffset: showCheck ? '0' : '20',
                  transition: 'stroke-dashoffset 0.5s ease-in-out 0.2s',
                }}
              />
            </svg>
          </div>

          {/* Content */}
          <div className="flex-1">
            <div className="mb-1 text-base font-semibold text-gray-800">
              決済完了
            </div>
            <div className="text-sm text-gray-600">
              {symbol} - 数量：{qty}を決済しました
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettleSuccessPopup;
